const API_URL = process.env.REACT_APP_API_URL; 


const safeJsonParse = (text) => {
  if (!text) return null;
  if (text.startsWith("No")) return null; 
  try {
    return JSON.parse(text);
  } catch (e) {
    console.error(" JSON Parse Error:", text);
    return null;
  }
};


export async function fetchAddressTypes() {
  try {
    const res = await fetch(`${API_URL}MasterAPI/GetAddressType`);
    const text = await res.text();
    const data = safeJsonParse(text);
    return data?.data ?? data ?? [];
  } catch (err) {
    console.error("fetchAddressTypes error:", err);
    return [];
  }
}


export async function fetchAddressByUserId(userId) {
  try {
    const res = await fetch(
      `${API_URL}Customer/GetUserAddressByUserId/${userId}`
    );

    const text = await res.text();
    console.log(" Address Raw Response:", text);

    const data = safeJsonParse(text);
    return data?.data ?? data ?? [];
  } catch (err) {
    console.error("fetchAddressByUserId error:", err);
    return [];
  }
}

export async function addUserAddress(payload) {
  try {
    const body = {
      id: 0,
      addressTypeID: Number(payload.addressTypeID),
      addressType: null, // usually backend ignores, optional
      userId: String(payload.userId),
      addressTitle: payload.addressTitle,
      faltHousNumber: payload.faltHousNumber,
      street: payload.street,
      locality: payload.locality,
      pincode: payload.pincode,
      latitude: payload.latitude ?? "", // required
      longitude: payload.longitude ?? "", // required
      isDefault: payload.isDefault ?? true,
    };

    console.log(" Payload to backend:", body);

    const res = await fetch(`${API_URL}Customer/UserAddressesInsert`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const text = await res.text();
    console.log(" Add Address Raw Response:", text);

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }

    return {
      succeeded: data.success ?? data.succeeded ?? res.ok,
      message: data.message ?? "Saved successfully",
      data: data.data ?? null,
    };
  } catch (err) {
    console.error("addUserAddress error:", err);
    return { succeeded: false, message: "Network error, please try again" };
  }
}



export async function updateUserAddress(payload) {
  try {
    const res = await fetch(`${API_URL}Customer/UserAddressesUpdate`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const text = await res.text();
    const data = safeJsonParse(text);

    return {
      succeeded: data?.success ?? data?.succeeded ?? res.ok,
      message: data?.message ?? "Updated successfully",
      data: data?.data ?? null,
    };
  } catch (err) {
    console.error("updateUserAddress error:", err);
    return { succeeded: false, message: "Network error" };
  }
}


export async function deleteUserAddress(id) {
  try {
    const res = await fetch(
      `${API_URL}Customer/UserAddressesDeleteById?id=${id}`
    );

    const text = await res.text();
    const data = safeJsonParse(text);

    return {
      succeeded: data?.success ?? data?.succeeded ?? res.ok,
      message: data?.message ?? "Deleted successfully",
    };
  } catch (err) {
    console.error("deleteUserAddress error:", err);
    return { succeeded: false, message: "Network error" };
  }
}
